module.exports = __webpack_public_path__ + "img/straight_line_icon_124.c74b10de.svg";